import { format } from "date-fns";

const AddCalendar = ({ event }) => {
  if (!event?.main_date) return null;

  const title = event.title || "Live Music";
  const description = event.eventdescription || "Live Music Event";
  const location = event.venue_name || "Venue";
  const startDate = new Date(event.main_date);
  const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000); // 2 hours later

  const start = format(startDate, "yyyyMMdd'T'HHmmss'Z'");
  const end = format(endDate, "yyyyMMdd'T'HHmmss'Z'");

  const googleUrl = `https://www.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
    title
  )}&dates=${start}/${end}&details=${encodeURIComponent(
    description
  )}&location=${encodeURIComponent(location)}`;

  const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
BEGIN:VEVENT
SUMMARY:${title}
DTSTART:${format(startDate, "yyyyMMdd'T'HHmmss'Z'")}
DTEND:${format(endDate, "yyyyMMdd'T'HHmmss'Z'")}
LOCATION:${location}
DESCRIPTION:${description}
END:VEVENT
END:VCALENDAR
`.trim();

  const icsHref = `data:text/calendar;charset=utf8,${encodeURIComponent(
    icsContent
  )}`;

  return (
    <div style={{ marginTop: "1rem", display: "flex", gap: "1rem" }}>
      <a
        href={googleUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: "#4285F4",
          color: "#fff",
          padding: "8px 12px",
          borderRadius: "4px",
          textDecoration: "none",
          fontWeight: "bold",
        }}
      >
        📅 Add to Google Calendar
      </a>

      <a
        href={icsHref}
        download={`${title.replace(/\s+/g, "_")}.ics`}
        style={{
          backgroundColor: "#444",
          color: "#fff",
          padding: "8px 12px",
          borderRadius: "4px",
          textDecoration: "none",
          fontWeight: "bold",
        }}
      >
        📁 Download .ics
      </a>
    </div>
  );
};

export default AddCalendar;
